import { AnyExtension, Node } from '@tiptap/core';
import { InlineNodes, NodeGroup } from '../available-extensions';

/**
 * Schema-only twin of the Angular SnippetAutocompleteNodeComponent — prevents TipTap
 * from dropping unregistered nodes during HTML serialisation (PDF generation).
 */
export const snippetAutocompleteSerialisation = Node.create({
  name: InlineNodes.SnippetAutocomplete,
  content: `${InlineNodes.Text}*`,
  group: NodeGroup.Inline,
  inline: true,
  defining: true,

  addAttributes() {
    return {
      uid: { default: undefined },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0];
  },

  parseHTML() {
    return [];
  },
}) as AnyExtension;
